import { createStore } from 'vuex';
import VuexPersistence from 'vuex-persist';
import config from './modules/config';
import auth from './modules/auth';
import redirect from './modules/redirect';
import company from './modules/company';

const vuexLocalStorage = new VuexPersistence({
	storage: window.localStorage,
	modules: ['auth']
});

const vuexSessionStorage = new VuexPersistence({
	storage: window.sessionStorage,
	modules: ['config', 'redirect', 'company']
});

export default createStore({
	plugins: [
		vuexLocalStorage.plugin,
		vuexSessionStorage.plugin
	],
	modules: {
		config: config,
		auth: auth,
		redirect: redirect,
		company: company
	}
});